module.exports = __webpack_public_path__ + "static/media/Pre-footer-illustrations.3beace14.svg";